<template>
  <div ref="splide" class="splide">
    <div class="splide__track">
      <ul class="splide__list">
        <li v-for="(month, key, index) in filteredCalendarEvents" class="splide__slide">
          <div v-if="!miniCalendar" class="calendar__header-section">
            <h2 class="calendar__current-month-heading">{{ formatMonthHeading(key) }}</h2>
            <button
                :disabled="index === 0"
                type="button"
                class="calendar__month-button calendar__month-button--prev"
                aria-controls="splide01-track"
                @click="prevSlide"
            >
              <span class="calendar__month-button-icon round-button round-button--prev">
                <span class="calendar__month-button-icon-plate round-button__icon"></span>
              </span>
              <span class="calendar__month-button-text heading heading--medium" v-if="index !== 0"><span class="sr-only">{{this.translations.PreviousMonth}}: </span>{{formatMonth(Object.keys(filteredCalendarEvents)[index - 1])}}</span>
              <span class="calendar__month-button-text sr-only" v-else>{{this.translations.PreviousMonth}}</span>
            </button>
            <button
                :disabled="index + 1 === numberOfMonths"
                type="button"
                class="calendar__month-button calendar__month-button--next"
                aria-controls="splide01-track"
                @click="nextSlide"
            >
              <span class="calendar__month-button-text heading heading--medium" v-if="index + 1 < numberOfMonths"><span class="sr-only">{{this.translations.NextMonth}}: </span>{{formatMonth(Object.keys(filteredCalendarEvents)[index + 1])}}</span>
              <span class="calendar__month-button-text sr-only" v-else>{{this.translations.NextMonth}}</span>
              <span class="calendar__month-button-icon round-button round-button--next">
                <span class="calendar__month-button-icon-plate round-button__icon"></span>
              </span>
            </button>
          </div>
          <ul class="calendar__event-items section__content section__content--listing"
              :class="[
                itemDisplayOption === 'Halva' ? 'section__content--halves' : 'section__content--thirds',
                { 'calendar__event-items--centered': isStartPage }
              ]">
            <Calendar
                v-for="calendar in getUniqueCalendarEvents(month)"
                :key="calendar.CalendarItemPageReference"
                :calendar="calendar"
                :translations="translations"
                :culture="culture"
                @onError="onError"
            />
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Calendar from "./calendar.vue";
import Splide from '@splidejs/splide';

export default {
  name: "CalendarList",
  props: {
    filteredCalendarEvents: [],
    translations: {},
    culture: "",
    miniCalendar: false,
    itemDisplayOption: '',
    isStartPage: false,
    focusEventIndex: null,
    useDarkGreenBlue: false,
  },
  components: {
    Calendar: Calendar,
  },
  data() {
    return {
      splide: {}
    };
  },
  mounted() {
    this.initSplide();
  },
  methods: {
    onError: function (error) {
      this.$emit("onError", error);
    },
    initSplide: function () {
      const options = {
        type: 'fade',
        arrows: false,
        keyboard: 'focused',
        pagination: false
      };

      this.splide = new Splide(this.$refs.splide, options);
      this.splide.mount();

      this.goToCurrentMonth();
    },
    nextSlide: function () {
      this.splide.go('>');
    },
    prevSlide: function () {
      this.splide.go('<');
    },
    goToCurrentMonth: function () {
      if (this.miniCalendar) {
        return;
      }

      // Go to the current year and month in the full calendar.
      const today = new Date();
      const currentMonthKey = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;

      Object.keys(this.filteredCalendarEvents).forEach((month, index) => {
        if (month === currentMonthKey) {
          this.splide.go(index);
        }
      });
    },
    formatMonthHeading(monthKey) {
      const [year, month] = monthKey.split('-').map(Number);
      return new Date(year, month - 1, 1).toLocaleString(this.culture, { month: 'long', year: 'numeric' });
    },
    formatMonth(monthKey) {
      const [year, month] = monthKey.split('-').map(Number);
      return new Date(year, month - 1, 1).toLocaleString(this.culture, { month: 'long' });
    },
    getUniqueCalendarEvents(monthArray) {
      const seen = new Set();
      return monthArray.filter(item => {
        const id = item.CalendarItemPageReference;
        if (seen.has(id)) {
          return false;
        }
        seen.add(id);
        return true;
      });
    }
  },
  computed: {
    numberOfMonths: function () {
      return Object.keys(this.filteredCalendarEvents).length;
    },
    showMiniCalendar: function () {
      return this.miniCalendar;
    },
  },
  watch: {
    filteredCalendarEvents: {
      handler: function () {
        if (this.miniCalendar) {
          return;
        }

        // Use setTimeout to make sure the DOM is updated before destroying and reinitializing the splide
        setTimeout(() => {
          this.splide.destroy(true);
          this.initSplide();
        });
      }
    },
    focusEventIndex: function (index) {
      if (!this.miniCalendar || index === null) {
        return;
      }

      this.$nextTick(() => {
        const eventItems = this.$el.querySelectorAll('.calendar__event-item');
        const firstNewEventLink = eventItems[index]?.querySelector('.site-page-partial__link');
        firstNewEventLink?.focus();
      });
    }
  }
};
</script>
